import React from 'react'
import { Nav } from 'react-bootstrap'
//import { LinkContainer } from 'react-router-bootstrap'
import { Link } from 'react-router-dom'

function CheckoutSteps({ step1, step2, step3, step4 }) {
    return (

        <Nav className='mb-4 justify-content-center'>
            <Nav.Item>
                {step1 ? (
                    <Link to='/login?redirect=/shipping'>
                        Login
                    </Link>
                ) : (
                    <Nav.Link disabled>Login</Nav.Link>
                )}
            </Nav.Item>
            <Nav.Item>
                {step2 ? (
                    <Link to='/shipping'>
                        Shipping
                    </Link>
                ) : (
                    <Nav.Link disabled>Shipping</Nav.Link>
                )}
            </Nav.Item>
            <Nav.Item>
                {step3 ? (
                    <Link to='/payment'>
                        Payment
                    </Link>
                ) : (
                    <Nav.Link disabled>Payment</Nav.Link>
                )}
            </Nav.Item>
            <Nav.Item>
                {step4 ? (
                    <Link to='/placeorder'>
                        PlaceOrder
                    </Link>
                ) : (
                    <Nav.Link disabled>PlaceOrder</Nav.Link>
                )}
            </Nav.Item>
        </Nav>



    )
}

export default CheckoutSteps
